import React from "react";
import { Stack, ProgressIndicator } from "@fluentui/react";

export interface LoadingProps {
    label?: string;
    description?: string;
    minHeight? : string;
};

const Loading: React.FC<LoadingProps> = props => (
    <Stack horizontal verticalFill verticalAlign="center" horizontalAlign="center" style={{minHeight: props.minHeight ?? "100vh", textAlign: "center", padding: 20}}>
        <Stack.Item grow shrink={0}>
            <ProgressIndicator {...props} barHeight={5} />
        </Stack.Item>
    </Stack>
);

export default Loading;